import React from 'react'

function FormButton({ content, handleSubmit }) {
  return (
    <button
      type='submit'
      onClick={handleSubmit}
      className='bg-red-4 text-white text-center w-full p-2 md:p-3 
      justify-center border border-red-4 rounded-full hover:text-red-4 
      hover:bg-white hover:border-red-4 transition-colors duration-300
      text-xs md:text-sm'
    >
      {content}
    </button>
  )
}

export default FormButton